export const store = {
    state: {
        pagePeriod: "",
        page:1,
        disPrevBtn: "",
        disNextBtn: "",
        perPage:100
    },
    //get pagination from to to page number
    getPagePeriod(perPage,total) {
                
        var pageTo = this.state.page * perPage;
        var pageFrom = ( pageTo - perPage ) + 1;
        //if total records less than 1 then pageFrom = 0 and show 0 - 0
        if (total < 1) {
            pageFrom = 0;
        }

        if ( pageTo < total ) {
            this.state.pagePeriod = pageFrom +" - "+ pageTo;
            //enable next button
            this.state.disNextBtn = "";
        } else {
            this.state.pagePeriod = pageFrom +" - "+ total;
            //disable next button
            this.state.disNextBtn = "disabled";
        }

        if ( this.state.page == 1 ) {
            this.state.disPrevBtn = "disabled";
        }
        
    },
    //change the page number when query in backend 
    pageChange(flag) {

        if ( flag == 'next') {
            
            this.state.page = this.state.page + 1;

        } else if ( flag == 'prev' ) {

            //if current page is 1 than do not decrement
            if (this.state.page != 1 ) {
                this.state.page = this.state.page - 1;
            }
            
        } else if ( flag == 'reset' ) {
            this.state.page = 1;
        }
        //disable prev button if page is 1st else enable
        if ( this.state.page == 1 ) {
            this.state.disPrevBtn = "disabled";
        } else {
            this.state.disPrevBtn = "";
        }
        
    },
    perPageChange(perPageCount) {
        this.state.perPage = perPageCount;
    }
    
    
};


// WEBPACK FOOTER //
// ./src/store/paginationStore.js